import React from 'react';

const Square = ({value, onClick}) => (
    <button onClick={onClick} className='Square'>{value}</button>
)

export default Square